import React, { ChangeEventHandler, FC, memo, useRef, useState } from 'react';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import Search from '@/public/icon/Search.svg';
import styles from './SearchInput.module.scss';
import { useRouter } from 'next/router';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppState } from '@/store';
import { changeKeyword } from '@/store/slices/sortFilterSlice';
import SearchIcon from '@/public/icon/search-input.svg';
import Image from 'next/image';

type Props = {
  className?: string;
  placeholder?: string;
  onClick?: (ev: any) => void;
};

const SearchInput: FC<Props> = memo(({ className, placeholder, onClick }) => {
  const [focused, setFocused] = useState(false);
  const router = useRouter();

  const dispatch = useDispatch<any>();
  const { language, keyword } = useSelector(
    (state: AppState) => ({
      language: state.homePage.language,
      keyword: state.sortFilter.keyword
    }),
    shallowEqual
  );

  const goToSearch = (ev: any, value: string) => {
    if (keyword.trim()) {
      // unknown reason about missing header's css, so use this way to create new tab // 2024.06.20
      typeof onClick === 'function'
        ? onClick(ev)
        : (window.location.href = `${window.location.origin}/${language.value}/blog/search`);
    }
  };

  const handleKeyDown = async (event: any, value: string) => {
    if (event.key === 'Enter') {
      await goToSearch(event, value);
    }
  };

  return (
    <div
      className={classNames(styles.Search_Input, className, {
        [styles.Input_Focused]: focused
      })}
    >
      <input
        value={keyword}
        placeholder={placeholder}
        className={styles.Input}
        onChange={ev => dispatch(changeKeyword(ev.target.value))}
        onKeyDown={e => handleKeyDown(e, keyword)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <span
        className={classNames(styles.Search_Icon, { [styles.hover_icon]: focused })}
        onClick={e => goToSearch(e, keyword)}
      >
        <Icon component={SearchIcon} className={styles.icon} style={{ fontSize: 48 }} />
      </span>
    </div>
  );
});

export default SearchInput;
